

















































































import { Component, Vue } from "vue-property-decorator";
import FlightClass from "@/store/entities/flight/flightClass";
@Component({})
export default class AddFlightClass extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  flightClass: FlightClass = new FlightClass();

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    this.flightClass = this.$store.state.flightClass.editFlightClass;
    if (this.flightClass == null) {
      this.isEdit = false;
      this.flightClass = new FlightClass();
    } else {
      this.isEdit = true;
    }
  }

  async saveFlightClass() {
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "flightClass/saveFlightClass",
        data: this.flightClass,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "flightClass/saveFlightClass",
        data: this.flightClass,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.flightClass.editFlightClass = null;
  }
}
